import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-no-data',
  templateUrl: './no-data.component.html',
  standalone: true,
})
export class NoDataComponent {
  @Input() message = 'Nessun risultato';
  @Input() img: string = 'mood_bad';
}
